import React from 'react';
import { Card } from 'antd';
import CodeBlock from './CodeBlock';

const ViewLogs = ({ onCopy }) => {
  const logCommands = [
    {
      code: 'journalctl | grep rapid',
      description: 'Log Commands:',
      subDescription: 'Filters system logs for rapid service entries.\nDisplays relevant log messages.',
    },
    {
      code: 'journalctl | grep servicemonitor.service',
      subDescription: 'Shows logs specific to servicemonitor.service.\nHelps diagnose service issues.',
    },
  ];

  return (
    <Card title="View All Service Logs" bordered={false}>
      {logCommands.map((command, index) => (
        <CodeBlock
          key={index}
          code={command.code}
          description={command.description}
          subDescription={command.subDescription}
          onCopy={onCopy}
        />
      ))}
    </Card>
  );
};

export default ViewLogs; 